<template>
  <el-dialog
    :model-value="modelValue"
    title="修改模板"
    width="460px"
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
  >
    <el-form label-position="top" :model="form">
      <el-form-item label="模板别名" required>
        <el-input v-model="form.alias" maxlength="60" show-word-limit placeholder="模板名称" />
      </el-form-item>
      <el-form-item label="可见范围">
        <el-radio-group v-model="form.visibility">
          <el-radio :label="0">
            <span>个人</span>
            <span class="opt-hint">只有我能看到</span>
          </el-radio>
          <el-radio :label="1">
            <span>公开</span>
            <span class="opt-hint">同项目所有人可见</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="template" class="meta-info">
        <p>所属项目：{{ template.project_name || template.project_code || '-' }}</p>
        <p>创建人：{{ template.created_name || template.created_by || '-' }}</p>
      </div>
    </el-form>
    <template #footer>
      <el-button @click="emit('update:modelValue', false)">取消</el-button>
      <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { updateTemplate } from '../reportDataTemplateApi'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  template:   { type: Object,  default: null }
})

const emit = defineEmits(['update:modelValue', 'saved'])

const saving = ref(false)
const form = reactive({ alias: '', visibility: 0 })

watch(
  () => [props.modelValue, props.template],
  () => {
    if (!props.modelValue || !props.template) return
    form.alias = props.template.alias || ''
    form.visibility = props.template.visibility === 1 ? 1 : 0
  },
  { immediate: true }
)

async function handleSave() {
  if (!props.template?.id) return
  if (!form.alias.trim()) {
    ElMessage.warning('请填写模板别名')
    return
  }
  saving.value = true
  try {
    await updateTemplate(props.template.id, {
      alias: form.alias.trim(),
      visibility: form.visibility
    })
    ElMessage.success('模板已更新')
    emit('saved', {
      id: props.template.id,
      alias: form.alias.trim(),
      visibility: form.visibility
    })
    emit('update:modelValue', false)
  } catch (err) {
    ElMessage.error('保存失败：' + (err.message || '未知错误'))
  } finally {
    saving.value = false
  }
}
</script>

<style scoped>
.opt-hint {
  font-size: 12px;
  color: #94a3b8;
  margin-left: 4px;
}

.meta-info {
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.8;
}

.meta-info p {
  margin: 0;
}
</style>
